export { default } from './DischargePatientModal';
export { default as dischargePatient } from './utils/dischargePatient';
